export default "__VITE_ASSET__CkFTobCq__"